import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandingContext = createContext(null);
const DEFAULT = { appName: "Holistor", logoUrl: "", logoLight: "", logoDark: "", tagline: "Desarrollamos Software.", footerText: "Holistor · Herramientas para profesionales de nómina · Argentina · CCT 130/75 · Ley 20.744", primaryColor: "#0F172A", secondaryColor: "#3B82F6" };

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  const apply = (b) => {
    setBranding(b);
    document.documentElement.style.setProperty("--brand-primary", b.primaryColor || "#0F172A");
    document.documentElement.style.setProperty("--brand-secondary", b.secondaryColor || "#3B82F6");
    const p = window.location.pathname;
    if (p.startsWith("/app") || p.startsWith("/admin")) {
      document.title = `${b.appName || "Holistor"} — Calculadora SAC`;
    }
  };

  const refresh = () => api.get("/branding").then((r) => apply(r.data)).catch(() => apply(DEFAULT));

  useEffect(() => {
    refresh();
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, refresh, apply }}>{children}</BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
